module.exports = __webpack_public_path__ + "img/importer.cd77c351.png";